import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const UserInfoBlock = ({ userData }) => {
  if (!userData) return null;

  return (
    <>
      <hr />
      <FormGroup>
        <Label>Status</Label>
        <div>
          <span
            className={`badge badge-${userData.active ? "success" : "secondary"}`}
          >
            {userData.active ? "Active" : "Inactive"}
          </span>
        </div>
      </FormGroup>

      <FormGroup>
        <Label>Verified</Label>
        <div>
          <span
            className={`badge badge-${userData.verified ? "success" : "warning"}`}
          >
            {userData.verified ? "Verified" : "Not Verified"}
          </span>
        </div>
      </FormGroup>

      {userData.createdDate && (
        <FormGroup>
          <Label>Created Date</Label>
          <div>
            <Input
              type="text"
              value={new Date(userData.createdDate).toLocaleString()}
              disabled
            />
          </div>
        </FormGroup>
      )}
    </>
  );
};

export default UserInfoBlock;
